<script setup lang="ts">
import { mergeProps, useAttrs } from "vue";

/** The standard "create/add a record" control: a round primary + icon. [label] is the tooltip
 * and accessible name, so the button stays findable by role and name. */
defineOptions({ inheritAttrs: false });
defineProps<{ label: string }>();
const attrs = useAttrs();
</script>

<template>
  <v-tooltip :text="label" location="top">
    <template #activator="{ props: tooltipProps }">
      <v-btn
        v-bind="mergeProps(attrs, tooltipProps)"
        color="primary"
        rounded="xl"
        density="comfortable"
        icon="mdi-plus"
        :aria-label="label"
      />
    </template>
  </v-tooltip>
</template>
